var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowforward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7101 11.7102L11.7101 6.71019C11.8011 6.61508 11.8725 6.50294 11.9201 6.38019C12.0201 6.13672 12.0201 5.86365 11.9201 5.62019C11.8725 5.49743 11.8011 5.38529 11.7101 5.29019L6.7101 0.290185C6.61687 0.196947 6.50618 0.122986 6.38435 0.072526C6.26253 0.0220657 6.13196 -0.00390625 6.0001 -0.00390625C5.7338 -0.00390625 5.47841 0.101882 5.2901 0.290185C5.1018 0.478489 4.99601 0.733884 4.99601 1.00019C4.99601 1.26649 5.1018 1.52188 5.2901 1.71019L8.5901 5.00019L1.0001 5.00019C0.734887 5.00019 0.480533 5.10554 0.292996 5.29308C0.10546 5.48062 0.000103951 5.73497 0.000103951 6.00019C0.000103951 6.2654 0.10546 6.51976 0.292996 6.70729C0.480533 6.89483 0.734887 7.00019 1.0001 7.00019L8.5901 7.00019L5.2901 10.2902C5.19637 10.3831 5.12198 10.4937 5.07121 10.6156C5.02044 10.7375 4.99431 10.8682 4.99431 11.0002C4.99431 11.1322 5.02044 11.2629 5.07121 11.3848C5.12198 11.5066 5.19637 11.6172 5.2901 11.7102C5.38307 11.8039 5.49367 11.8783 5.61553 11.9291C5.73739 11.9798 5.86809 12.006 6.0001 12.006C6.13212 12.006 6.26282 11.9798 6.38468 11.9291C6.50654 11.8783 6.61714 11.8039 6.7101 11.7102Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowforward);
export default __webpack_public_path__ + "static/media/arrow forward.7d6f1743f48345b92ac125b9b36c4d83.svg";
export { ForwardRef as ReactComponent };